export default __webpack_public_path__ + "static/media/1-1-3.a728518d.webp";